import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconReminderFalse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReminderFalse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a7ed25589ed69b407ebd46734cafe8c455aff988', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7efd8715f6cd34ecb77be4f5d7c7d5ef9e27b859', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '852bc3fb64ddbe0cf080c8c3e1270315a0969a73', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m3.41 2.35 16.24 16.24a.51.51 0 0 1-.04.71l-.35.35a.51.51 0 0 1-.71 0l-4.66-4.66H4.44a.49.49 0 0 1-.44-.72 10.7 10.7 0 0 0 1.11-4.7 8.2 8.2 0 0 1 .52-2.88L2.35 3.41a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0m5.137 14.93A.51.51 0 0 1 9 17h4a.51.51 0 0 1 .36.81 3 3 0 0 1-4.77 0 .51.51 0 0 1-.043-.53M6 13.49a12.3 12.3 0 0 0 .64-3.92 8 8 0 0 1 .21-1.69l5.61 5.61zM8.51 3.48A5.4 5.4 0 0 1 11 3c3.66 0 5.93 3.12 5.92 6.63v2.27a.5.5 0 0 1-.5.5.52.52 0 0 1-.36-.16l-.43-.44a.66.66 0 0 1-.21-.53V9.63c0-2.55-1.52-5.13-4.42-5.13a4.8 4.8 0 0 0-1.77.31.51.51 0 0 1-.6-.14l-.34-.43a.54.54 0 0 1-.1-.3.5.5 0 0 1 .32-.46", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-reminder-false", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-reminder-false"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-reminder-false":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReminderFalse$1);
            }
            break;
    } });
}

const CosmosIconReminderFalse = CosmosIconReminderFalse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReminderFalse, defineCustomElement };
